import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCategoryGift';
/** Renders an SVG icon. */
const SvgCategoryGift = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.385 16.503a.75.75 0 0 1-.064 1.058L13.13 19.5l2.19 1.938a.75.75 0 0 1-.995 1.123l-2.823-2.5a.75.75 0 0 1 0-1.123l2.823-2.5a.75.75 0 0 1 1.06.065m2.585.967a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
      />
      <path
        fill="currentColor"
        d="m16.604 20.646.792-.793a.5.5 0 0 0 0-.707l-.792-.793a.5.5 0 0 0-.708 0l-.792.793a.5.5 0 0 0 0 .707l.792.793a.5.5 0 0 0 .708 0"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.981 2.707a3.515 3.515 0 0 1 5.094 1.596L16 6.461l.925-2.158a3.515 3.515 0 0 1 5.094-1.596C24 3.946 24.118 6.487 22.818 8H27a2 2 0 0 1 2 2v3a1 1 0 0 1-1 1v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V14a1 1 0 0 1-1-1v-3a2 2 0 0 1 2-2h4.182c-1.3-1.514-1.182-4.054.8-5.293Zm7.671 4.976 2.775-.504c1.362-.248 1.706-2.042.532-2.776a1.515 1.515 0 0 0-2.196.688zm-3.304 0-2.775-.504c-1.362-.248-1.706-2.042-.532-2.776a1.515 1.515 0 0 1 2.196.688l1.11 2.592ZM6 14v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V14zm21-2H5v-2h22z"
      />
    </svg>
  );
};
SvgCategoryGift.displayName = displayName;
export default SvgCategoryGift;
